import React from 'react';
import PropTypes from 'prop-types';
import Card from '../card/Card';

export const filterList = card => card.visible;

const CardsList = ({
  cards,
  crms,
  onClick,
}) => {
  return (
    <div className="accounts">
      {cards
        .filter(filterList)
        .map(card => (
          <Card
            key={card.name}
            onClick={onClick}
            selected={crms}
            {...card}
          />
        ))}
    </div>
  );
};

CardsList.propTypes = {
  cards: PropTypes.array.isRequired,
  crms: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CardsList;



// WEBPACK FOOTER //
// ./src/components/common/accounts/components/CardsList/CardsList.jsx